module.exports = __webpack_public_path__ + "media/img/frontend_application/navicon/black-fav-icon-b7d8b2279cdba0066a464d4c59b9ac11.svg";